import { useEffect, useState } from 'react';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { axiosInstance } from 'src/api/axios';
import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ToastMessage from '../../common/ToastMessage/index';

const CommonApproveDeniedAPI = () => {
  const navigate = useNavigate();
  //const [responseApprovedAPI, setResponseApprovedAPI] = useState('');
  const approveProviderData = async (Oid, tempuseroid, cb, ds, name) => {
    try {
      const ProviderApprovalAPI = await axiosInstance.post(
        APIEndpoints.postApproveAPICall() +
          `/worklistoid/${Oid}/tempuseroid/${tempuseroid}/status/Approved`,
      );
      //const doctorFacilityData = ProviderApprovalAPI?.status;
      //setResponseApprovedAPI(doctorFacilityData);
      if (cb) cb();
      if (ds) {
        navigate('/admin/approvals', { state: { tab: 'registration' } });
      }
      if (
        ProviderApprovalAPI.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        ProviderApprovalAPI.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
      ) {
        toast.success(
          <ToastMessage
            type="success"
            subTitle={`Provider Self-registration request for ${name}has been approved!`}
          />,
        );
      }
    } catch (error) {
      console.log(error);
      toast.error(
        <ToastMessage
          type="error"
          subTitle={`Provider Self-registration request for ${name} could not be approved at the moment! Try again later.`}
        />,
      );
    }
  };

  const deniedProviderData = async (Oid, tempuseroid, cb, ds, name) => {
    try {
      const response = await axiosInstance.post(
        APIEndpoints.putDeniedAPICall() +
          `/worklistoid/${Oid}/tempuseroid/${tempuseroid}/status/Denied`,
      );
      //const doctorFacilityData = response?.status;
      //setResponseApprovedAPI(doctorFacilityData);
      console.log('response', response);
      if (cb) cb();
      if (ds) {
        navigate('/admin/approvals', {
          state: { tab: 'registration' },
        });
      }
      if (
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
      ) {
        toast.success(
          <ToastMessage
            type="success"
            subTitle={`Provider Self-regristration request for ${name} has been denied!`}
          />,
        );
      }
    } catch (error) {
      console.log(error);
      toast.error(
        <ToastMessage
          type="error"
          subTitle={`Provider Self-registration request for ${name} could not be denied at the moment! Try again later.`}
        />,
      );
    }
  };

  return {
    approveProviderData,
    deniedProviderData,
  };
};

export default CommonApproveDeniedAPI;
